/**
 * Alcance documental de las consultas de empleados.
 * "None" apaga la funcionalidad para la empresa conservando su configuración.
 */
export enum DocQueryScope {
  None = 0,
  All = 1,
  Paychecks = 2
}

/** Valores de `documentTypeOption` en la API (`/DocMessages/Settings`). */
export type DocQueryDocumentTypeOption = 'Ninguno' | 'Todos' | 'Recibos';

/** Respuesta de `/DocMessages/Settings`. */
export interface DocQuerySettingsResponse {
  id: string;
  ouId: number;
  notifyEmails: string[];
  motives: string[];
  documentTypeOption: DocQueryDocumentTypeOption;
  creationDate: string;
  changedDate: string | null;
}

/** Payload de POST/PUT `/DocMessages/Settings`. */
export interface DocQuerySettingsRequest {
  ouId: number;
  notifyEmails: string[];
  motives: string[];
  documentTypeOption: DocQueryDocumentTypeOption;
}

/** Configuración de consultas de una empresa, ya mapeada para el frontend. */
export interface DocQuerySettings {
  id: string;
  ouId: number;
  scope: DocQueryScope;
  notifyEmails: string[];
  motives: string[];
}

/** Valores completos a persistir, incluido el alcance "None". */
export interface DocQuerySettingsValues {
  scope: DocQueryScope;
  notifyEmails: string[];
  motives: string[];
}
